module.exports = __webpack_public_path__ + "static/media/padlock.79a375b3.svg";